/**
 * Reconcile a client's visible timer with its event history. Scorekeepers can
 * switch players before the first pot starts the visible frame timer; those
 * actions still belong to the frame and must define its real start.
 */
export const resolveFrameStartTimestamp = (events, ...candidates) => {
    const timestamps = [
        ...(Array.isArray(events) ? events.map(event => event?.timestamp_ms) : []),
        ...candidates,
    ]
        .map(Number)
        .filter(timestamp => Number.isFinite(timestamp) && timestamp > 0);

    return timestamps.length ? Math.min(...timestamps) : null;
};
